import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n/config';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './styles/responsive.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
